module.exports = __webpack_public_path__ + "static/media/logo-sardegna-mobilita-nero.36b22836.svg";